/** Tutorial guidato dell'elenco Varianti. */
const at = name => `[data-tour-scope="variants-list"] [data-tour="${name}"]`;
const EDIT = '[data-tour="row-edit"]';

const visible = selector => {
	const element = document.querySelector(selector);
	return !!element && element.getClientRects().length > 0;
};

const pause = () => new Promise(resolve => setTimeout(resolve, 0));

async function openRowMenu() {
	await pause();
	if (!visible(EDIT)) document.querySelector(at('row-menu'))?.click();
}

export async function stopVariantsListTour() {
	if (visible(EDIT)) document.querySelector(at('row-menu'))?.click();
}

export function createVariantsListTourSteps() {
	return [
		{ body: "Le varianti descrivono le caratteristiche che distinguono le versioni di un prodotto, per esempio Taglia o Colore. Ogni variante contiene i propri valori.", key: 'intro', placement: 'bottom', target: at('tutorial'), title: 'Gestire le varianti' },
		{ body: "Il pulsante piu' apre la pagina per creare una nuova variante e i relativi valori.", key: 'add', placement: 'left', target: at('add'), title: 'Aggiungere una variante' },
		{ body: "Cerca una variante per nome, quindi premi Invio o la lente. Con meno di tre caratteri viene mostrato nuovamente l'elenco completo.", key: 'search', placement: 'bottom', target: at('search'), title: 'Cercare una variante' },
		{ body: "La tabella mostra stato, nome, numero di prodotti collegati, valori disponibili e disponibilita' come filtro sul sito.", key: 'table', placement: 'top', target: at('table'), title: 'Leggere l’elenco' },
		{ body: "Una bandierina per ogni lingua del negozio: a colori dove il nome della variante e' scritto, in grigio dove manca. Se scrivi nome e valori in una sola lingua, al salvataggio valgono anche per le altre lasciate vuote.", key: 'langs', placement: 'bottom', target: at('langs'), timeout: 250, title: 'Le lingue della variante' },
		{ body: "Questo interruttore attiva o disattiva rapidamente la variante senza aprire la scheda di modifica.", key: 'status', missing: 'skip', placement: 'right', target: at('status'), title: 'Stato della variante' },
		{ before: openRowMenu, body: "Dai tre pallini puoi modificare la variante. Elimina compare solo quando la variante non e' collegata ad alcun prodotto.", key: 'row-menu', placement: 'right', target: EDIT, timeout: 250, title: 'Azioni sulla variante' },
	];
}
